import { useActivitySessionTracker } from 'src/hooks/useActivitySessionTracker';

export function ActivitySessionTracker() {
  useActivitySessionTracker();

  return null;
}
